import React from "react";
import styled from "styled-components";

export default ({ title, items }) => (
  <Wrap>
    <Title>{title}</Title>
    <Box>
      {items.map((item, i) => (
        <div key={i}>
          <ItemTitle>{item.title}</ItemTitle>
          <ItemDesc>{item.desc}</ItemDesc>
        </div>
      ))}
    </Box>
  </Wrap>
);

const Title = styled.div`
  color: #a1a19f;
  font-size: 1.75rem;
  font-family: "CircularStd-Book", sans-serif;
  margin-bottom: 0.65rem;
`;

const ItemTitle = styled.div`
  font-family: "CircularStd-Book", sans-serif;
  font-size: 1.8rem;
`;

const ItemDesc = styled.div`
  font-family: "CircularStd-Book", sans-serif;
  margin-left: 0.5rem;
  color: #a1a19f;
  font-size: 1.25rem;
`;

const Wrap = styled.div`
  margin-bottom: 1.4rem;
`;

const Box = styled.div`
  background-color: #fff;
  padding: 2.5rem;
`;



// WEBPACK FOOTER //
// ./src/components/common/candidate/ScheduleCall/components/Section/index.js